var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { UserEdit } from "Server/CommandMacros";
import { Command } from "mobx-firelink";
import { GetAttribute } from "Store/firebase/attributes";
let DeleteAttribute = class DeleteAttribute extends Command {
    Validate() {
        let { id } = this.payload;
        //this.oldData = await GetAsync(()=>GetPost(postID));
        this.oldData = GetAttribute(id);
    }
    GetDBUpdates() {
        let { id } = this.payload;
        let updates = {};
        updates[`attributes/${id}`] = null;
        return updates;
    }
};
DeleteAttribute = __decorate([
    UserEdit
], DeleteAttribute);
export { DeleteAttribute };
